import axios from "axios";
import qs from "qs";
import config from "../config";

// 1. Define the shared configuration options
const commonConfig = {
  withCredentials: true,
  paramsSerializer: (params) => {
    return qs.stringify(params, {
      arrayFormat: "repeat",
      skipNulls: true,
    });
  },
};

// 2. Create a helper function to attach interceptors to any instance
const setupInterceptors = (instance) => {
  // Request Interceptor
  instance.interceptors.request.use(
    function (config) {
      // You can add logic here to remove trailing slashes or log requests
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  // Response Interceptor
  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response) {
        const { status, data } = error.response;

        // 401 Redirect Logic
        if (status === 401) {
          window.location.href = `${config.authUrl}/login?redirect=${window.location.href}`;
        }

        // Error Message Formatting
        if (data && data.message) {
          error.message = `Error ${status}: ${data.message}`;
        } else {
          error.message = `Error ${status}: An error occurred`;
        }
      } else {
        error.message = "Error: Network error or no response received";
      }

      return Promise.reject(error);
    }
  );
};

// 3. Create the specific instances

// The original instance
const cfbhAxios = axios.create({
  baseURL: `${config.apiUrl}/cfbh/api`,
  ...commonConfig,
});

// The new directory instance
const directoryAxios = axios.create({
  baseURL: config.clinicCentralBackendUrl,
  ...commonConfig,
});

// 4. Apply the interceptors to both
setupInterceptors(cfbhAxios);
setupInterceptors(directoryAxios);

// Export named exports for flexibility, and default for backward compatibility
export { cfbhAxios, directoryAxios };
export default cfbhAxios;
